import { createApp } from 'vue'
import VTooltip from 'v-tooltip'

import App from './App.vue'
import router from './router'
import store from './store'

import emitter from '@/lib/vue3-beautiful-chat/src/emitter.js'

const app = createApp(App)
app.config.globalProperties.$event = emitter
app.use(VTooltip).use(router).use(store).mount('#app')
